
import { Box, Text, Flex, Icon } from "@chakra-ui/react";
import { FaArrowUp, FaArrowDown, FaEquals } from "react-icons/fa";
import SystematicFactorsLineChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsLineChart";
import { useSelector } from "react-redux";
import SystematicFactorsStackedAreaChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsStackedAreaChart";
import BlurSection from "../../../shared/BlurSection/BlurSection";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

const TrendIndicator = ({ direction }) => {
  switch (direction) {
    case "up":
      return <Icon as={FaArrowUp} color="green.500" />;
    case "down":
      return <Icon as={FaArrowDown} color="red.500" />;
    default:
      return <Icon as={FaEquals} color="gray.500" />;
  }
};

const ObservationText = ({ observation }) => {
  if (!observation || observation.percentage === 0) {
    return (
      <Text fontSize="sm" color="gray.500">
        No observation data available
      </Text>
    );
  }

  return (
    <Flex align="center" gap={2}>
      <TrendIndicator direction={observation.direction} />
      <Text fontSize="sm">
        Observed {observation.trend} of {observation.percentage}% over{" "}
        {observation.percentage === 100
          ? "all"
          : `${observation.percentage}/7`}{" "}
        years
      </Text>
    </Flex>
  );
};

const Distribution = ({ graphData, isAuthenticatedUser, observations }) => {
  const smeActivityModule = useSelector(
    (state) => state.userModuleReducer?.data?.["SME Activity"] ?? {}
  );

  const averageInventorySorted = [...(graphData?.averageInventory || [])]
    .sort((a, b) => parseInt(a.year) - parseInt(b.year))
    .splice(1);

  const averageInventory = averageInventorySorted.map((d) => ({
    value: {
      averageInventory:
        ((d?.value?.currentInventory || 0) +
          (d?.value?.previousInventory || 0)) /
        2,
    },
    year: d.year,
  }));

  return (
    <>

      {/* Total Trade Receivables Chart */}
     <Box w="100%" mb={6} position="relative">
  
  <Box
    position="absolute"
    top="2"
    right="2"
    zIndex="1"
    bg="whiteAlpha.800"
    px="2"
    borderRadius="md"
    style={{
      filter: isAuthenticatedUser ? "none" : "blur(3px)",
      pointerEvents: isAuthenticatedUser ? "auto" : "none",
      transition: "filter 0.3s ease",
    }}
  >
    <ObservationText observation={observations?.totalTradeReceivables} />
  </Box>


  <SystematicFactorsStackedAreaChart
    data={graphData.totalTradeReceivables}
    heading="Total Trade Receivables"
    dimension={{ width: "100%", height: "230px" }}
  />

  {smeActivityModule &&
    smeActivityModule?.["Total Trade Receivables"] &&
    smeActivityModule["Total Trade Receivables"]?.["showBlur"] && (
      <BlurSection height={"80%"} width={"25%"} />
    )}
</Box>

   
<Box w="100%" position="relative">
  
  <Box
    position="absolute"
    top="2"
    right="2"
    zIndex="1"
    bg="whiteAlpha.800"
    px="2"
    borderRadius="md"
    style={{
      filter: isAuthenticatedUser ? "none" : "blur(3px)",
      pointerEvents: isAuthenticatedUser ? "auto" : "none",
      transition: "filter 0.3s ease",
    }}
  >
    <ObservationText observation={observations?.averageInventory || null} />
  </Box>


  <ResponsiveContainer width="100%" height={230}>
    <AreaChart
      data={averageInventory}
      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
    >
      <defs>
        <linearGradient id="colorAverageInventory" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#30D5C8" stopOpacity={0.4} />
          <stop offset="100%" stopColor="#30D5C8" stopOpacity={0.05} />
        </linearGradient>
      </defs>

      <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
      <XAxis dataKey="year" tick={{ fontSize: 12, fill: "#555" }} axisLine={{ stroke: "#ccc" }} />
      <YAxis
        tick={{ fontSize: 12, fill: "#555" }}
        axisLine={{ stroke: "#ccc" }}
        tickFormatter={(value) => `${(value / 10000000).toFixed(1)} Cr`} // Y-axis in Cr
      />
      <Tooltip formatter={(value) => `${(value / 10000000).toFixed(2)} Cr`} />
      <Area
        type="monotone"
        dataKey="value.averageInventory"
        stroke="#30D5C8"
        fill="url(#colorAverageInventory)"
        strokeWidth={2}
      />
    </AreaChart>
  </ResponsiveContainer>

  {smeActivityModule?.["Average Inventory"]?.["showBlur"] && (
    <BlurSection height={"80%"} width={"25%"} />
  )}
</Box>


    </>
  );
};

export default Distribution;
